import { inject, Pipe, PipeTransform } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

@Pipe({ name: 'multipleTranslate' })
export class MultipleTranslatePipe implements PipeTransform {
  private readonly translate: TranslateService = inject(TranslateService)

  transform(value: string, splitSymbol = ', ', joinSymbol = ', '): string {
    if (value) {
      return value
        .split(splitSymbol)
        .map((v) => this.translate.instant(v))
        .join(joinSymbol)
    }
    return value
  }
}
